import { inferAdditionalFields } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { API_URL } from './api-client.js';

/**
 * Client de session du dashboard.
 *
 * Trois points à ne pas défaire :
 *
 * 1. `baseURL` vise l'API, pas le dashboard. Better Auth vit sur le Worker
 *    (`/api/auth/*`) ; Cloudflare Pages ne sert que des fichiers statiques et
 *    répondrait `index.html` à toute requête d'authentification — un 200 avec
 *    du HTML, donc une erreur de parsing incompréhensible côté client.
 *
 * 2. `credentials: 'include'` est obligatoire : le cookie de session est posé
 *    sur `.myog.dev` par `api.myog.dev` et lu depuis `app.myog.dev`. Sans
 *    cette option, le navigateur n'envoie rien et toute session paraît
 *    expirée. Le pendant côté serveur est la liste `DASHBOARD_ORIGINS`
 *    (jamais un joker : un CORS permissif avec cookies est une faille).
 *
 * 3. `inferAdditionalFields` réintroduit `plan` dans le type de `user`. Sans
 *    lui, `session.user.plan` n'existe pas au typage — et l'interface
 *    afficherait la formule gratuite à un client payant.
 *
 * Le champ est déclaré `input: false` côté serveur : il ne change que par un
 * webhook Stripe, jamais depuis le navigateur.
 */
export const authClient = createAuthClient({
  baseURL: API_URL,
  fetchOptions: { credentials: 'include' },
  plugins: [
    inferAdditionalFields({
      user: {
        plan: { type: 'string', input: false },
      },
    }),
  ],
});

export const { useSession, signIn, signOut } = authClient;

export type Session = typeof authClient.$Infer.Session;
